/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
} from './Organization';
import type { Page } from './Page';
import {
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './Page';

/**
 * 
 * @export
 * @interface PageableOrganizations
 */
export interface PageableOrganizations {
    /**
     * 
     * @type {Array<Organization>}
     * @memberof PageableOrganizations
     */
    result: Array<Organization>;
    /**
     * 
     * @type {Page}
     * @memberof PageableOrganizations
     */
    page: Page;
}

/**
 * Check if a given object implements the PageableOrganizations interface.
 */
export function instanceOfPageableOrganizations(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function PageableOrganizationsFromJSON(json: any): PageableOrganizations {
    return PageableOrganizationsFromJSONTyped(json, false);
}

export function PageableOrganizationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageableOrganizations {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(OrganizationFromJSON)),
        'page': PageFromJSON(json['page']),
    };
}

export function PageableOrganizationsToJSON(value?: PageableOrganizations | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(OrganizationToJSON)),
        'page': PageToJSON(value.page),
    };
}

